import { useAuthContext } from '../../context/auth.context'

export const READ_ONLY_IMPERSONATING = "You're signed in as someone else, so you can read these notifications but not change them. End the impersonation to make changes."

// The person's own notification writes (read, read-all, archive,
// preferences, push sign-up) are refused while impersonating (R-IMP, 403
// notify.not_while_impersonating), so the admin offers none of them then.
export const useSelfNotifyAccess = () => {
  const { state } = useAuthContext()
  const impersonating = Boolean(state && state.jwtClaims && state.jwtClaims.impersonationEndsAt)
  return { canWrite: !impersonating, impersonating, reason: impersonating ? READ_ONLY_IMPERSONATING : null }
}
